import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FrameDesktopComponent } from "../frame-desktop/frame-desktop.component";
import { FrameMobileComponent } from "../frame-mobile/frame-mobile.component";
import { FrameTabletComponent } from "../frame-tablet/frame-tablet.component";
import { MainScreenComponent } from "./main-screen.component";
import { RouterModule } from "@angular/router";
import { LoginModule } from "../../shared/login.module";
import { RecurrenceChangePanelComponent } from "../../recurrence/recurrence-change-panel/recurrence-change-panel.component";
import { RecurrenceCancelPanelComponent } from "../../recurrence/recurrence-cancel-panel/recurrence-cancel-panel.component";
import { EmptyDetailsComponent } from "../../shared/empty-details/empty-details.component";

@NgModule({
  declarations: [
    FrameDesktopComponent,
    FrameMobileComponent,
    FrameTabletComponent,
    MainScreenComponent,
  ],
  imports: [
    EmptyDetailsComponent,
    CommonModule,
    RouterModule.forRoot([]),
    LoginModule,
    // de terugkeer-panelen schuiven in het keuzepaneel van elk frame
    RecurrenceChangePanelComponent,
    RecurrenceCancelPanelComponent,
  ],
  exports: [
    FrameDesktopComponent,
    FrameMobileComponent,
    FrameTabletComponent,
    MainScreenComponent,
  ],
})
export class MainScreenModule {}
